module.exports = __webpack_public_path__ + "img/FeaturedItem.5ff858bf.svg";